export default class LmsCourseResolverErrorDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { dateCreated: json.dateCreated && new Date(json.dateCreated) });
    }
}
